var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackdropMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 632,
    viewBox: "0 0 375 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_879_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 384,
    r: 134,
    fill: "url(#paint0_linear_879_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_879_2",
    x: -114,
    y: 0,
    width: 768,
    height: 768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_879_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_879_2",
    x1: 404,
    y1: 250,
    x2: 136,
    y2: 518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0675B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdropMobile);
export default __webpack_public_path__ + "static/media/backdropMobile.88fbb1b2f99376622a13de5f4bc1b32f.svg";
export { ForwardRef as ReactComponent };